import "./style.css";

const AdminTextArea = ({ placeholder = "", mb = "mb-3", onChange, value, name = "", label = null, disabled = false }) => {
  return (
    <>
      <div className={mb}>
        {label && <label className="tw:!mb-1 tw:!text-[15px] tw:!text-[#8D8D8D]">{label}</label>}
        <textarea
          name={name}
          className={`
            tw:w-full 
            tw:!rounded 
            tw:!py-2 
            tw:!px-2 
            tw:!border-1 
            tw:!border-[#E8E8E8]
            tw:!text-[15px]
            tw:!font-['Hanken_Grotesk']
            tw:placeholder:!text-[15px] 
            tw:placeholder:!font-['Hanken_Grotesk'] 
            tw:focus:placeholder:!opacity-0
          `}
          id=""
          rows={4}
          placeholder={placeholder}
          onChange={(e) => onChange(e)}
          value={value}
          disabled={disabled}
        >
        </textarea>
      </div>
    </>
  );
};

export default AdminTextArea;
